
import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  isRecommendation?: boolean;
}

const Input: React.FC<InputProps> = ({ label, id, error, isRecommendation, ...props }) => {
  const hasError = error && !isRecommendation;
  const hasRecommendation = error && isRecommendation;
  
  return (
    <div className="min-w-0">
      <label htmlFor={id} className="block text-sm font-medium text-gray-300 mb-1">
        {label}
        {props.required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <input
        id={id}
        className={`w-full min-w-0 max-w-full box-border bg-gray-700 border rounded-md shadow-sm px-3 py-2 text-white placeholder-gray-400 focus:outline-none focus:ring-2 ${
          hasError 
            ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
            : hasRecommendation
            ? 'border-yellow-500 focus:ring-yellow-500 focus:border-yellow-500'
            : 'border-gray-600 focus:ring-indigo-500 focus:border-indigo-500'
        }`}
        {...props}
      />
      {error && (
        <p className={`mt-1 text-sm ${hasError ? 'text-red-400' : 'text-yellow-400'}`}>
          {hasError ? '❌ ' : '💡 '}{error}
        </p>
      )}
    </div>
  );
};

export default Input;
